export default __webpack_public_path__ + "static/media/werkethicalbumart.e9e6a7a4.jpg";